import { render, staticRenderFns } from "./PrintJournalDriver.vue?vue&type=template&id=1d16f1c3"
import script from "./PrintJournalDriver.vue?vue&type=script&lang=js"
export * from "./PrintJournalDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports